import React, { useState } from "react";
import PageSeo from "../../components/seo/PageSeo";
import {Navigate, Link } from "react-router-dom";
import { Trans } from "react-i18next";
import { changePassCall, keyCall } from "../../calls";
import { useTranslation } from "react-i18next";
import "./changePassword.css";
import "../../components/login/auth-signal.css";

/* SETTINGS (Change password + API key) — design "Signal" */
const ChangePass = (props) => {
  const { setIsLoggedIn, isLoggedIn, setLoader } = props;
  const { t } = useTranslation();

  const [passData, setPassData] = useState({
    old_password: "",
    password: "",
    confirm_password: "",
  });
  const [error, setError] = useState([]);
  const [success, setSuccess] = useState("");
  const [key, setKey] = useState("");
  const [show, setShow] = useState({ old: false, new: false, confirm: false });
  const [copied, setCopied] = useState(false);

  const handleDataChange = (e) => {
    setPassData({ ...passData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(false);
    setError([]);
    setSuccess("");
    changePassCall(passData)
      .then((response) => {
        setLoader(true);
        setPassData(response.data);
        setSuccess(t("signal.pw-updated"));
      })
      .catch((err) => {
        setLoader(true);
        if (err.response && err.response.status === 401) {
          setIsLoggedIn(false);
          localStorage.removeItem("token");
        }
        // Messages serveur fixes (users/views.py, users/serializers.py) traduits
        const d = err?.response?.data || {};
        if (err?.response?.status === 406 || /old password/i.test(d.message || "")) {
          setError([t("signal.pw-old-wrong")]);
        } else if (d.confirm_password) {
          setError([t("signal.pw-mismatch")]);
        } else {
          setError([t("signal.pw-update-failed")]);
        }
      });
  };

  const handleGetKey = () => {
    setLoader(false);
    keyCall()
      .then((response) => {
        setLoader(true);
        setKey(response.data.key);
      })
      .catch((err) => {
        setLoader(true);
        if (err.response && err.response.status === 401) {
          setIsLoggedIn(false);
          localStorage.removeItem("token");
        }
      });
  };

  if (!isLoggedIn) return <Navigate replace to="/" />;

  const fields = [
    { id: "old_password", name: "old_password", label: t("overview.old-pass"), k: "old" },
    { id: "password", name: "password", label: t("overview.new-pass"), k: "new" },
    { id: "confirm_password", name: "confirm_password", label: t("overview.confirm-new-pass"), k: "confirm" },
  ];

  return (
    <div className="sg-page">
      <PageSeo noindex title={t("overview.settings")} />
      <div className="sg-cols">
        {/* Changer le mot de passe */}
        <div className="sg-panel" style={{ flex: "1 1 380px", minWidth: 300 }}>
          <h1 className="sg-h1" style={{ marginBottom: 16 }}>{t("overview.change-pass")}</h1>
          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            {fields.map((f) => (
              <div className="auth-field" key={f.id}>
                <span className="auth-field__label">{f.label}</span>
                <div className="auth-field__box">
                  <input
                    required
                    value={passData[f.name] || ""}
                    onChange={handleDataChange}
                    type={show[f.k] ? "text" : "password"}
                    id={f.id}
                    name={f.name}
                    placeholder="••••••••"
                    autoComplete={f.k === "old" ? "current-password" : "new-password"}
                  />
                  <button
                    type="button"
                    className="auth-field__show"
                    onClick={() => setShow({ ...show, [f.k]: !show[f.k] })}
                  >
                    {show[f.k] ? t("signal.auth-hide") : t("signal.auth-show")}
                  </button>
                </div>
              </div>
            ))}
            {error.map((e, i) => (
              <p key={i} className="auth-card__error">{e}</p>
            ))}
            {success && (
              <p className="sg-status sg-status--ok" style={{ fontSize: 13 }}>{success}</p>
            )}
            <button type="submit" className="sg-btn sg-btn--primary" style={{ alignSelf: "flex-start" }}>
              {t("overview.change-pass")}
            </button>
          </form>
        </div>

        {/* Clé API */}
        <div className="sg-panel" style={{ flex: "1 1 380px", minWidth: 300 }}>
          <h2 className="sg-h1" style={{ fontSize: 18, marginBottom: 8 }}>{t("signal.api-key-title")}</h2>
          <p className="sg-sub" style={{ marginBottom: 16 }}>{t("overview.change-pass-des")}</p>
          {key === "" ? (
            <button className="sg-btn sg-btn--primary" onClick={handleGetKey}>
              {t("overview.get-key")}
            </button>
          ) : (
            <div className="sg-field">
              <span className="sg-label">{t("signal.api-key-label")}</span>
              <div className="sg-copybox">
                <span className="sg-copybox__v sg-copybox__v--sm">{key}</span>
                <button
                  className="sg-copy"
                  onClick={() => {
                    navigator.clipboard.writeText(key);
                    setCopied(true);
                    setTimeout(() => setCopied(false), 1500);
                  }}
                >
                  {copied ? `✓ ${t("signal.copied")}` : t("signal.copy")}
                </button>
              </div>
              <p className="sg-note">
                <Trans
                  i18nKey="signal.api-key-usage"
                  values={{ header: "Authorization: Bearer <key>" }}
                  shouldUnescape
                  components={{
                    code: <code className="sg-mono" />,
                    docs: <Link to="/api-docs" style={{ color: "var(--color-primary)", fontWeight: 600, textDecoration: "none" }} />,
                  }}
                />
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChangePass;
